import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { MONTHLY_HOLDING_ENDPOINT } from "../config/urls";
import AppTable from "../common/app-table";

const tableColumns = [
  { id: "client_code",           label: "Client Code",                render: (h) => h.client.client_code  },
  { id: "client_name",           label: "Name",                       render: (h) => h.client.client_name  },
  { id: "phone_no",              label: "Phone Number",               render: (h) => h.client.phone_no     },
  { id: "val_date",              label: "Value Date"                                                        },
  { id: "one_month_return",      label: "One Month Return (%)"                                              },
  { id: "six_month_return",      label: "Six Month Return (%)"                                              },
  { id: "one_year_return",       label: "One Year Return (%)"                                               },
  { id: "three_year_return",     label: "Three Year Return (%)"                                             },
  { id: "five_year_return",      label: "Five Year Return (%)"                                              },
  { id: "since_inception_return",label: "Since Inception Return (%)"                                       },
];

export default function MonthlyHoldingsTable({ searchInput, refreshKey, dateInput }) {
  const [rowCount, setRowCount]     = useState(0);
  const [holdings, setHoldings]     = useState([]);
  const [loading, setLoading]       = useState(false);
  const [controller, setController] = useState({ page: 0, rowsPerPage: 20 });

  // Reset to page 0 on search change
  useEffect(() => {
    setController({ page: 0, rowsPerPage: 20 });
  }, [searchInput, dateInput]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const searchURL     = searchInput ? `&search_value=${searchInput}` : "";
        const searchDateURL = dateInput   ? `&search_date=${dayjs(dateInput).format("YYYY-MM-DD")}` : "";
        const user          = JSON.parse(localStorage.getItem("user"));
        const tenant        = localStorage.getItem("tenant");

        const response = await fetch(
          `${MONTHLY_HOLDING_ENDPOINT}?user_id=${user.id}&limit=${controller.rowsPerPage}&offset=${
            controller.page * controller.rowsPerPage
          }${searchURL}${searchDateURL}`,
          { headers: { "Content-Type": "application/json", "X-Tenant-Id": tenant } }
        );
        if (!response.ok) throw new Error("Failed to fetch data");
        const jsonData = await response.json();
        setHoldings(jsonData.results);
        setRowCount(jsonData.count);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setHoldings([]);
        setRowCount(0);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [controller, searchInput, refreshKey, dateInput]);

  const handlePageChange        = (event, newPage) => setController((prev) => ({ ...prev, page: newPage }));
  const handleChangeRowsPerPage = (event) => setController({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });

  return (
    <AppTable
      columns={tableColumns}
      rows={holdings}
      rowKey={(holding, index) => index}
      loading={loading}
      emptyMessage="No match found"
      maxHeight={440}
      count={rowCount}
      page={controller.page}
      rowsPerPage={controller.rowsPerPage}
      rowsPerPageOptions={[20]}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
}